import {
   HealthcareFacilityPart,
   HealthcareFacilityPartForCurrentOrganizationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { OrderingMap, paginations } from '@dreryk/command-query-ws-client';

type UseHealthcareFacilityPartForCurrentOrganizationCqrsSearchOptions = {
   enabled: boolean;
   orderingMap?: OrderingMap<HealthcareFacilityPart>;
};

export const useHealthcareFacilityPartForCurrentOrganizationCqrsSearch = (
   options?: UseHealthcareFacilityPartForCurrentOrganizationCqrsSearchOptions
): UseCqrsQueryResult<HealthcareFacilityPart[]> => {
   return useCqrsSearch(
      () => {
         return new HealthcareFacilityPartForCurrentOrganizationQuery();
      },
      options?.orderingMap ? paginations.all<HealthcareFacilityPart>().orderedByMap(options.orderingMap) : undefined,
      options
   );
};
